import {
  AfterViewInit,
  Component,
  OnInit,
  Input,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BaseComponent,
  SearchResult,
  ConfigurationSetting,
  getUrlParams,
} from 'src/app/shared';
import { BehaviorSubject } from 'rxjs';
import { ClaimService } from '../../services/claim.service';
import {
  ConfigurationService,
  InpageAliasService,
  LogService,
  Session,
} from 'src/app/my-sedgwick';
import { UserDetails } from '../../services/userdetails.service';
import { PharmacyCard } from 'src/app/shared/models/pharmacy-card';
import { ClaimDataService } from 'src/app/shared/services/claim-data.service';
import { ClaimInfo } from 'src/app/shared/models/search-result';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-pharmacy-card-page',
    template: `
    <app-section class="tw-w-full">
      @if (!printMode) {
        <div class="tw-w-full">
          <app-claim-breadcrumb></app-claim-breadcrumb>
        </div>
      }
      <app-panel
        [headerLevel]="2"
        title="Pharmacy Card"
        class="tw-w-full"
        [flat]="printMode"
        [canExpand]="false"
        [headerLevel]="1"
        >
        <app-loading-panel [state]="loading ? 'Loading' : 'Loaded'">
          <ng-template #content>
            @if (!printMode) {
              <iframe
                class="print-frame"
                (load)="printLoaded()"
                id="print-frame"
                >
              </iframe>
            }
            <div class="tw-w-full tw-flex tw-flex-wrap">
            <app-claim-header
              [summary]="claim"
              class="tw-w-full"
            ></app-claim-header>
            </div>
            <app-action-row *ngIf="!printMode">
              <app-button
                icon="print"
                [loading]="printing"
                left1
                emphasis="High"
                (click)="print()"
                label="Print"
              >
              </app-button>
            </app-action-row>

            <div id="print-section" class="print-section" *ngIf="!loading">
              <div class="app-pb1 app-pt3">
                <app-header-label class="headingbold" type="Header2" headerLabel="Front"
                  ></app-header-label
                >
              </div>

              <div class="card-container" id="print-section" *ngIf="!loading">
                <div class="card-section-1 tw-w-full">
                    {{'The pharmacy benefit card is ONLY to be used for medications prescribed for your work related injury' | translation: translationRequest}}
                </div>
                <div class="card-section-2 tw-w-full tw-flex tw-flex-wrap">
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="Claim Number"
                    layout="col"
                    [value]="claim.claimNumber"
                    [translationNeeded]="false"
                    [addColon]="true"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="Phone"
                    layout="col"
                    [value]="pharmacyCard.pharmacyPhone"
                    [translationNeeded]="false"
                    [addColon]="true"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="Network"
                    layout="col"
                    [value]="pharmacyCard.network"
                    [translationNeeded]="false"
                    [addColon]="true"
                  ></app-value>

                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="Type"
                    layout="col"
                    [value]="claim.claimDescription"
                    [addColon]="true"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="RxBIN"
                    layout="col"
                    [value]="pharmacyCard.bin"
                    [translationLabelNeeded]="false"
                    [addColon]="true"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="RxPCN"
                    layout="col"
                    [value]="pharmacyCard.pcn"
                    [translationLabelNeeded]="false"
                    [addColon]="true"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="RxGROUP"
                    layout="col"
                    [value]="pharmacyCard.rxGroup"
                    [translationLabelNeeded]="false"
                    [addColon]="true"
                  ></app-value>
                </div>
                <div class="card-section-3 tw-w-full tw-flex tw-flex-wrap">
                  <div class="tw-w-full md:tw-w-1/3 print:tw-w-1/3">
                    <img
                      src="./assets/images/pic_medicalcard.png"
                      width="190"
                      height="223"
                      alt=""
                    />
                  </div>
                  <div class="tw-w-full md:tw-w-2/3 print:tw-w-2/3 ">
                    <div
                      class="tw-flex tw-flex-wrap tw-justify-start tw-w-full"
                    >
                      <app-value
                        class="titlecase tw-basis-1/2 md:tw-w-[50%]"
                        label="Name"
                        layout="row"
                        [value]="pharmacyCard.claimantName"
                        [translationNeeded]="false"
                      ></app-value>
                      <app-value
                        class="titlecase tw-basis-1/2 md:tw-w-[50%]"
                        label="Phone"
                        layout="row"
                        [value]="pharmacyCard.claimantPhone"
                        [translationNeeded]="false"
                      ></app-value>

                      <app-value
                        class="titlecase tw-basis-1/2 md:tw-w-[50%]"
                        label="Employer"
                        layout="row"
                        [value]="pharmacyCard.employer"
                        [translationNeeded]="false"
                      ></app-value>
                      <app-value
                        class="titlecase tw-basis-1/2 md:tw-w-[50%]"
                        label="Fax"
                        layout="row"
                        [value]="pharmacyCard.claimantFax"
                        [translationNeeded]="false"
                      ></app-value>

                      <app-value
                        class="titlecase tw-basis-1/2 md:tw-w-[50%]"
                        label="Date of Injury"
                        layout="row"
                        [value]="pharmacyCard.dateEvent | format : 'date'"
                        [translationNeeded]="false"
                      ></app-value>
                      <app-value
                        class="titlecase tw-basis-1/2 md:tw-w-[50%]"
                        label="Mailing Address"
                        layout="col"
                        [translationNeeded]="false"
                        [valueTemplate]="mailingAddressTpl"
                      >
                        <ng-template #mailingAddressTpl>
                        <span
                          [innerHTML]="
                            pharmacyCard.claimantMailingAddress | address
                          "
                        >
                        </span>
                        </ng-template>
                      </app-value>

                      <div class=" tw-basis-full ">
                        <div class="app-pb1">
                          <b>{{ 'Pharmacist Instructions' | translation: translationRequest}}</b>
                        </div>
                        <div class="app-pl3">
                          <ul class="tw-list-disc">
                            <li
                              *ngFor="
                                let instruction of pharmacyCard.pharmacistInstructions
                                  | pipeToBulletPoints
                              "
                            >
                              {{ instruction | sentenceCase | translation: translationRequest }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="!pharmacyCard.participatingPharmacies"
                  class="card-section-4 tw-w-full tw-flex tw-flex-wrap"
                >
                  <div class="tw-w-full tw-text-center app-pb1">
                    {{'Participating pharmacies include but are not limited to:' | translation: translationRequest}}
                  </div>
                  <div class="tw-basis-1/4"></div>
                  <div class="tw-basis-1/4 tw-text-center">Walgreens</div>
                  <div class="tw-basis-1/4 tw-text-center">Walmart</div>
                  <div class="tw-basis-1/4"></div>

                  <div class="tw-basis-1/4"></div>
                  <div class="tw-basis-1/4 tw-text-center">CVS</div>
                  <div class="tw-basis-1/4 tw-text-center">Safeway</div>
                  <div class="tw-basis-1/4"></div>

                  <div class="tw-basis-1/4"></div>
                  <div class="tw-basis-1/4 tw-text-center">Kroger</div>
                  <div class="tw-basis-1/4 tw-text-center">Rite Aid</div>
                  <div class="tw-basis-1/4"></div>
                </div>
                <div
                  *ngIf="pharmacyCard.participatingPharmacies"
                  class="card-section-4 tw-w-full tw-flex tw-flex-wrap"
                >
                  <div class="tw-w-full tw-text-center app-pb1">
                    {{'Participating pharmacies include but are not limited to:' | translation: translationRequest}}
                  </div>
                  <div
                    *ngFor="
                      let pharmacy of pharmacyCard.participatingPharmacies;
                      let i = index
                    "
                    class="tw-basis-1/4 tw-text-center"
                  >
                    <div>{{ pharmacy }}</div>
                  </div>
                </div>
              </div>
              <div class="pagebreak"></div>

              <div class="app-pb1 app-pt3">
                <app-header-label class="headingbold" type="Header2" headerLabel="Back"
                  ></app-header-label
                >
              </div>

              <div class="card-container" id="print-section" *ngIf="!loading">
                <div class="card-section-1 tw-w-full">
                  {{'The pharmacy benefit card is ONLY to be used for medications prescribed for your work related injury' | translation: translationRequest}}
                </div>
                <div class="card-section-2 tw-w-full tw-flex tw-flex-wrap">
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="Claim Number"
                    layout="col"
                    [addColon]="true"
                    [value]="claim.claimNumber"
                    [translationNeeded]="false"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="Phone"
                    layout="col"
                    [addColon]="true"
                    [value]="pharmacyCard.pharmacyPhone"
                    [translationNeeded]="false"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="Network"
                    layout="col"
                    [addColon]="true"
                    [value]="pharmacyCard.network"
                    [translationNeeded]="false"
                  ></app-value>

                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="Type"
                    layout="col"
                    [addColon]="true"
                    [value]="claim.claimDescription"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="RxBIN"
                    layout="col"
                    [addColon]="true"
                    [value]="pharmacyCard.bin"
                    [translationLabelNeeded]="false"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="RxPCN"
                    layout="col"
                    [addColon]="true"
                    [value]="pharmacyCard.pcn"
                    [translationLabelNeeded]="false"
                  ></app-value>
                  <app-value
                    class="tw-w-[50%] md:tw-w-[33%]"
                    label="RxGROUP"
                    layout="col"
                    [addColon]="true"
                    [value]="pharmacyCard.rxGroup"
                    [translationLabelNeeded]="false"
                  ></app-value>
                </div>
                <div class="card-section-3 tw-w-full tw-flex tw-flex-wrap">
                  <div class="tw-w-full md:tw-w-1/3 print:tw-w-1/3">
                    <img
                      src="./assets/images/pic_medicalcard.png"
                      width="190"
                      height="223"
                      alt=""
                    />
                  </div>
                  <div class="tw-w-full md:tw-w-2/3 print:tw-w-2/3 ">
                    <div class="app-pb1">
                      <b>{{'Instructions for Your Medical Providers' | translation: translationRequest}}</b>
                    </div>
                    <div class="app-pl3">
                      <ul class="tw-list-disc">
                        <li>
                          {{'For authorization of services please fax medical records and request to Sedgwick Utilization Review at 877-922-7236.' | translation: translationRequest}}
                        </li>
                        <li>
                          {{'Please ensure that the claim number is forwarded with all documentation and medical bills.' | translation: translationRequest}}
                        </li>
                        <li>
                          {{('Please mail medical bills to the Claims' | translation: translationRequest) + ' ' + (examinerLabel | aliasTransform:'none') + ' ' + ('mailing address listed above.' | translation: translationRequest)}}
                        </li>
                        <li>
                          {{'If you have any questions related to claimant care, please contact Sedgwick Utilization Review at 866-286-0281.' | translation: translationRequest}}
                        </li>
                        <li>
                          {{'For bill payment status go to providerselfservice.sedgwickcms.net' | translation: translationRequest}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="card-section-4 tw-w-full tw-flex tw-flex-wrap">
                  <div class="tw-w-full tw-text-center app-pb1">
                    <span><b>{{'Scheduling Services' | translation: translationRequest}}</b></span
                    ><br />
                    <span>
                      {{'For all Sedgwick Specialty Services Contact Provider Connection: 1-87-SEDGWICK (1-877-334-9425)' | translation: translationRequest}}</span
                    >
                  </div>

                  <div class="hidden md:block md:tw-w-1/4"></div>
                  <div class="tw-w-1/2 md:tw-basis-1/4  tw-text-center">
                    {{'Physical Therapy' | translation: translationRequest}}
                  </div>
                  <div class="tw-w-1/2 md:tw-basis-1/4  tw-text-center">
                    {{'Transportation' | translation: translationRequest}}
                  </div>
                  <div class="hidden md:block md:tw-w-1/4"></div>

                  <div class="hidden md:block md:tw-w-1/4"></div>
                  <div class="tw-w-1/2 md:tw-basis-1/4  tw-text-center">
                    {{'Durable Medical Equipment' | translation: translationRequest}}
                  </div>
                  <div class="tw-w-1/2 md:tw-basis-1/4  tw-text-center">
                    {{'Translation' | translation: translationRequest}}
                  </div>
                  <div class="hidden md:block md:tw-w-1/4"></div>

                  <div class="hidden md:block  md:tw-w-1/4"></div>
                  <div class="tw-w-1/2 md:tw-basis-1/4  tw-text-center">
                    {{'Diagnostics' | translation: translationRequest}}
                  </div>
                  <div class="tw-w-1/2 md:tw-basis-1/4  tw-text-center">
                    {{'Dental' | translation: translationRequest}}
                  </div>
                  <div class="hidden md:block  md:tw-w-1/4"></div>
                </div>
              </div>
              <div class="app-pb8"></div>
            </div>
          </ng-template>
        </app-loading-panel>
      </app-panel>
    </app-section>
  `,
  styles: [
    `
      .card-container {
        max-width: 800px;
        border: 1px solid #f2f2f2;
        border-radius: 20px;
      }
      .card-section-1 {
        border-radius: 20px 20px 0 0;
        background-color: var(--sed-black-80-color);
        color: white;
        padding: 20px;
      }
      .card-section-2 {
        background-color: var(--sed-grey-40-color);
        padding: 20px;
        color: #171c20;
      }
      .card-section-3 {
        background-color: white;
        padding: 20px;
        color: #171c20;
      }
      .card-section-4 {
        background-color: var(--sed-black-80-color);
        color: white;
        padding: 20px;
        border-radius: 0 0 20px 20px;
      }
      .print-frame {
        position: absolute;
        left: -100%;
        height: 100px;
        width: 100px;
      }
      .print-section {
        print-color-adjust: exact;
      }
      @media print {
        .pagebreak {
          clear: both;
          page-break-after: always;
          break-after: page;
        }
      }
      .titlecase {
        text-transform: lowercase;
        text-transform: capitalize;
      }
      .pbMargins {
        margin-top: 10em;
      }
    `,
    ],
    standalone: false
})
export class PharmacyCardPageComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input()
  claim: SearchResult = <SearchResult>{};

  claimId: string;
  source: string;
  lob: string;
  isIncidentalClient: boolean = false;
  pharmacyCard: PharmacyCard;
  loading = true;
  printMode = false;
  printing = false;
  claimInfo$ = new BehaviorSubject<ClaimInfo>(null);
  claimConfig: ConfigurationSetting;
  examinerLabel: Aliases;
  aliases: any;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public session: Session,
    public userdetails: UserDetails,
    public logService: LogService,
    public claimService: ClaimService,
    private claimDataService: ClaimDataService,
    private configurationService: ConfigurationService,
    public inpageAliasService: InpageAliasService
  ) {
    super();
  }
  ngAfterViewInit(): void {}
  async ngOnInit() {
    const params = getUrlParams();
    this.claimId = params.claimId;
    this.source = params.source;

    this.subs.sink = this.claimDataService.currentClaim$.subscribe((claim) => {
      if (claim) {
        this.claim = claim;
      }
    });

    if (
      this.claim === null ||
      this.claim === undefined ||
      Object.keys(this.claim).length === 0
    ) {
      this.claim = await this.claimService.getSummary(
        this.source,
        this.claimId
      );
    }

    this.setClaim(this.claim);
    this.loadClaim();

    this.aliases = JSON.parse(sessionStorage.getItem('aliases'));
    if (!this.aliases) {
      this.aliases = this.configurationService.GetConfig.configFeatures.aliases;
      sessionStorage.setItem('aliases', JSON.stringify(this.aliases));
    }

    if (!this.aliases) this.aliases = sessionStorage.getItem('aliases');
    this.examinerLabel = await this.inpageAliasService.replaceAliases(
      'examinerSingularPossessive',
      this.aliases
    );

    this.subs.sink = this.route.url.subscribe((url) => {
      this.printMode = url[0].path === 'pharmacy-card-print';
    });
  }

  override ngOnDestroy() {
    sessionStorage.removeItem('aliases');
  }

  private async setClaim(claim: SearchResult) {
    if (claim === null || claim === undefined) {
      return;
    }
    this.claimId = claim.claimId;
    this.claimInfo$.next(claim);
    this.claim = claim;
    this.lob = claim.lob;
  }

  print() {
    this.printing = true;
    let el: any = document.getElementById('print-frame');
    this.claimDataService.setClaim(this.claim);
    el.contentWindow.location = `/pharmacy-card-print?claimId=${this.claim.claimId}&source=${this.claim.source}`;
  }

  private async loadClaim() {
    const pharmacyCardRequest = this.claimService.getPharmacyCard(
      this.claim.source,
      this.claim.claimId,
      this.claim.lob
    );

    this.pharmacyCard = await pharmacyCardRequest;
    this.loading = false;

    if (this.printMode) {
      setTimeout(() => {
        this.printing = true;
        window.print();
      }, 500);
    }
  }

  printLoaded() {
    this.printing = false;
  }
}
